export default __webpack_public_path__ + "static/media/baysel1.482b6879.png";